const cache = new Map<string, MediaQueryList>();

class MediaQueryCache {
  get = (cacheKey: string) => {
    return cache.get(cacheKey);
  };

  set = (cacheKey: string, mediaQuery: MediaQueryList) => {
    cache.set(cacheKey, mediaQuery);
  };

  wipe = () => {
    cache.clear();
  };
}

/** Manages global cache of media queries to reuse them (major performance impact) */
const singleton = new MediaQueryCache();

export { singleton as MediaQueryCache };
